import { isSessionAlmSynced } from "@/backend/read/BackendReader";
import type { StickyType } from "@/model/stickyType";
import { isStickyTypeAlmSynced } from "@/store/stickyType";

export function maxStickyTextLength() {
  return isSessionAlmSynced() ? 255 : 640;
}

export function hardBreaksAllowed(type: StickyType) {
  return !isStickyTypeAlmSynced(type);
}
